export class Constant {
    // public static api = 'https://sisfac.aquiconzepedalogistic.com';
    public static api = 'https://dev-sisfac.aquiconzepedalogistic.com';
    // public static api = 'http://localhost:27885';
    // public static apiGuias = 'https://ws.aquiconzepedalogistic.com';
    public static apiGuias = 'https://dev-ws.aquiconzepedalogistic.com';
    // public static apiGuias = 'http://localhost:44393';

}
